module.exports = __webpack_public_path__ + "static/media/menu-marketing.836813b5.svg";